import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { X, Globe } from 'lucide-react';
import { usePresenterStore } from '@store/presenterStore';

export default function EmbeddedBrowser(): React.ReactElement {
  const { browserUrl, setBrowserUrl, setBrowserOpen } = usePresenterStore();
  const [inputUrl, setInputUrl] = useState(browserUrl || 'https://www.google.com');
  const [iframeUrl, setIframeUrl] = useState(browserUrl || 'https://www.google.com');
  const iframeRef = React.useRef<HTMLIFrameElement>(null);

  const navigate = () => {
    let url = inputUrl.trim();
    if (!url.startsWith('http')) url = `https://${url}`;
    setIframeUrl(url);
    setBrowserUrl(url);
  };

  return (
    <motion.div
      className="fixed inset-4 z-[9020] glass rounded-3xl overflow-hidden shadow-glass pointer-events-auto flex flex-col"
      initial={{ scale: 0.9, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
    >
      {/* Browser chrome */}
      <div className="flex items-center gap-2 px-4 py-3 border-b border-surface-border">
        <Globe size={14} className="text-slate-500 flex-shrink-0" />
        <input
          type="text"
          value={inputUrl}
          onChange={(e) => setInputUrl(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && navigate()}
          className="flex-1 bg-surface-elevated border border-surface-border rounded-lg px-3 py-1.5 text-xs text-slate-900 focus:outline-none focus:border-brand-500"
          placeholder="Enter URL…"
        />
        <button onClick={navigate}
          className="px-3 py-1.5 bg-brand-500 hover:bg-brand-600 rounded-lg text-xs text-white font-medium transition-colors">
          Go
        </button>
        <button onClick={() => setBrowserOpen(false)}
          className="p-1.5 rounded-lg text-slate-500 hover:text-slate-900 hover:bg-surface-elevated transition-colors">
          <X size={16} />
        </button>
      </div>

      {/* iframe */}
      <iframe
        ref={iframeRef}
        src={iframeUrl}
        className="flex-1 w-full border-0 bg-white"
        sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
        title="Embedded Browser"
      />
    </motion.div>
  );
}
